import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { Tag } from "@flixbus/honeycomb-react";
import { type TokenKind } from "../FormulaEditor.types";
import styles from "./PaletteChip.module.scss";

interface PaletteChipProps {
  id: string;
  kind: TokenKind;
  value: string;
  label: string;
  onAdd: (kind: TokenKind, value: string) => void;
}

const PaletteChip: React.FC<PaletteChipProps> = ({
  id,
  kind,
  value,
  label,
  onAdd,
}) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id,
    data: { source: "palette", kind, value },
  });
  return (
    <span
      ref={setNodeRef}
      className={isDragging ? styles.paletteChipDragging : undefined}
      {...attributes}
      role={undefined}
      {...listeners}
    >
      {kind === "var" ? (
        <Tag
          Elem="button"
          display="subtle"
          appearance="success"
          onClick={() => onAdd(kind, value)}
        >
          {label}
        </Tag>
      ) : (
        <Tag
          Elem="button"
          display="outlined"
          onClick={() => onAdd(kind, value)}
        >
          {label}
        </Tag>
      )}
    </span>
  );
};

export default PaletteChip;
